module.exports = __webpack_public_path__ + "img/watermelon-smoothie.ed573a96.jpg";